<template>
  <div id="supplier-delivery-date-changer" class="text-xs-center">
    <v-dialog persistent v-model="dialog" :width="200 * otherSuppliers.length">
      <v-card>
        <v-card-text>
          <div class="table-wrapper">
            <div class="rTable">
              <div class="rTableRow problem-header">
                <div
                  class="rTableHead"
                  v-for="(supplier, i) in otherSuppliers"
                  :key="i"
                >{{supplier.title}}</div>
              </div>
              <div class="rTableRow">
                <div
                  class="rTableCell"
                  v-for="(supplier, i) in otherSuppliers"
                  :key="i+1000"
                  @click="pickDate($event, order.getOrderSuppliers(supplier.id))"
                  @contextmenu="showContextMenu($event, order.getOrderSuppliers(supplier.id))"
                >{{order.getSupplierDate(supplier)}}</div>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions @click="closeDatePicker">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >{{ $t("supplier_delivery_date_changer.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DatePicker ref="datePicker" @dateSelected="saveDate" />
    <v-menu
      class="selection-menu"
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list>
        <v-list-tile @click="removeDate">
          <v-list-tile-title>{{$t('production_info.clean')}}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import Order from "@/models/Order.js";
import Product from "@/models/Product.js";
import Helper from "@/models/Helper.js";
export default {
  name: "supplier-delivery-date-changer",
  components: {
    DatePicker,
  },
  props: {
    showingSuppliers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    suppliers: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      loading: false,
      dateMenu: false,
      completionDate: null,
      dialog: false,
      order: null,
      otherSuppliers: [],
      confirming: false,
      showMenu: false,
      x: 0,
      y: 0,
      onKeyUp: (e) => {
        if (e.key === "Escape" && !this.confirming) {
          this.dialog = false;
        }
      },
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.closeDatePicker();
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },
  methods: {
    async open(order, suppliers) {
      this.order = order;
      this.otherSuppliers = this.getOtherSuppliers(suppliers);
      this.otherSuppliers.forEach((supplier) => {
        supplier.furthest_date = this.getSupplierDate(supplier);
      });
      this.dialog = this.otherSuppliers.length > 0 ? true : false;
    },

    showContextMenu(e, suppliers) {
      e.preventDefault();
      this.closeDatePicker();
      this.edittingSuppliers = suppliers;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },

    closeDatePicker() {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.manualClose();
      }
    },

    getOtherSuppliers(orderSuppliers) {
      return this.suppliers.filter((supplier) => {
        const foundSupplier = orderSuppliers.find((e) => {
          return e.supplier_id == supplier.id;
        });
        return foundSupplier;
      });
    },

    getSupplierDate(supplier) {
      let furthestDate = new Date("1970-01-01");
      for (const orderSupplier of this.order.suppliers) {
        if (!orderSupplier.confirmed_delivery_date) {
          continue;
        }
        if (supplier.id === orderSupplier.supplier_id) {
          const newDate = new Date(orderSupplier.confirmed_delivery_date);
          if (newDate.getTime() > furthestDate.getTime()) {
            furthestDate = newDate;
          }
        }
      }
      return Helper.getDate(furthestDate);
    },

    pickDate(event, suppliers) {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.open(event, suppliers);
      }
    },

    async saveDate(selectedDate, suppliers) {
      console.log(selectedDate, suppliers);
      for (const supplier of suppliers) {
        supplier.ordered_at = Helper.getDate(supplier.ordered_at);
        supplier.confirmed_delivery_date = selectedDate;
        await supplier.save();
      }
      this.$emit("saved");
    },

    async removeDate(){
      for(const supplier of this.edittingSuppliers){
        await supplier.clearDate();
      }
      this.$emit("saved");
    }
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
  width: 100px;
  height: 15px;
  overflow: hidden;
}
.date {
  border: 0;
  width: 100px;
  height: 15px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
}
.picker {
  width: 200px;
  height: 15px;
  font-size: 999px;
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
}
.selection-menu {
  z-index: 1001;
}
</style>
